angular.module('bmsApp.global', [
	'bmsApp.global.direction'
]);
